exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h1,\nh2 {\n  color: white;\n}\n\n.white {\n  color: white!important;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /usr/src/app/src/app/_components/transporteur/transporteur.component.css
// module id = ../../../../../src/app/_components/transporteur/transporteur.component.css
// module chunks = main